<template lang="pug">
v-container.py-8.pl-4
  template(v-if="isFetching && !fetchingData")
    v-row(no-gutters)
      v-col
        v-skeleton-loader(type="article")
      v-col
        v-skeleton-loader(type="image")
  template(v-else)
    feedback-form-setup(:fetchingData="fetchingData")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FeedbackFormSetup from '@/components/review/settings/FeedbackFormSetup.vue'

export default {
  name: 'FeedbackFormTab',
  components: {
    FeedbackFormSetup,
  },
  data() {
    return {
      isFetching: true,
      fetchingData: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  async mounted () {
    this.isFetching = true
    try {
      await this.fetchFormFields()
      this.isFetching = false
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchFormFields() {
      return this.$axios.get(`/reviews/${this.company.slug}/form_fields`)
        .then(({ data }) => {
          this.fetchingData = data
        })
    },
  },
}
</script>

<style scoped>
</style>